import { QUIZ_QUERY_PARAMS } from '@mc/find-my-classes'
import { paths } from '@mc/paths'

type CtaPathOptions = {
  skipQ1?: boolean
  categories?: number[]
  personaOptions?: string[]
}

export const ctaPath = ({
  skipQ1,
  categories,
  personaOptions,
}: CtaPathOptions) => {
  const base = paths.classRecommendations

  const qp = new URLSearchParams()

  // pen-5209_v1_quiz_user_persona_question
  if (personaOptions) {
    qp.set(QUIZ_QUERY_PARAMS.PERSONA_OPTIONS, personaOptions.join(','))
  }
  if (categories) {
    qp.set(QUIZ_QUERY_PARAMS.SELECTED_CATEGORIES, categories.join(','))
  }
  if (skipQ1) {
    qp.set(QUIZ_QUERY_PARAMS.SKIP_Q1, 't')
  }

  const hasParams = [...qp.keys()].length === 0

  return base + (hasParams ? '' : `?${qp.toString()}`)
}
